var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.003.03h14.895v17.924H.003z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0275B6",
    d: "M13.62.03h-9.9A1.28 1.28 0 0 0 2.442 1.31v.816H1.278A1.28 1.28 0 0 0 0 3.403v13.272a1.28 1.28 0 0 0 1.278 1.279h9.9a1.28 1.28 0 0 0 1.279-1.279v-.816h1.163a1.28 1.28 0 0 0 1.278-1.278V1.309A1.28 1.28 0 0 0 13.62.03zm-2.186 16.645c0 .141-.115.256-.255.256h-9.9a.256.256 0 0 1-.256-.256V3.403c0-.14.114-.255.255-.255h1.164V14.58a1.28 1.28 0 0 0 1.278 1.278h7.714v.816zm2.442-2.094c0 .14-.115.255-.256.255h-9.9a.256.256 0 0 1-.256-.255V1.309c0-.141.115-.256.256-.256h9.9c.141 0 .256.115.256.256V14.58z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0275B6",
    d: "M17.42 6.206h-7.5a.512.512 0 0 0 0 1.023h7.5a.511.511 0 1 0 0-1.023zM17.42 8.64h-7.5a.511.511 0 0 0 0 1.022h7.5a.511.511 0 1 0 0-1.022zM17.42 11.073h-7.5a.512.512 0 0 0 0 1.023h7.5a.511.511 0 1 0 0-1.023zM17.42 13.507h-7.5a.512.512 0 0 0 0 1.023h7.5a.511.511 0 1 0 0-1.023z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.65e812243369d735528773493c959ccf.svg";
export { ForwardRef as ReactComponent };